import { render, staticRenderFns } from "./AttendeeList.vue?vue&type=template&id=4dade838&"
import script from "./AttendeeList.vue?vue&type=script&lang=js&"
export * from "./AttendeeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports